import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Messaging is browser-only; guard against SSR / unsupported browsers
let _messaging = null;
try {
  _messaging = getMessaging(app);
} catch (_) {}

/**
 * Get the FCM device token and persist it to Firestore so Cloud Functions
 * can send background push notifications to this device.
 * Safe to call on every login — setDoc with merge:true is idempotent.
 */
export async function saveToken(userId) {
  if (!userId || !_messaging) return;
  try {
    // Register the FCM worker explicitly so it resolves under PUBLIC_URL
    // (e.g. a GitHub Pages project subpath) instead of the origin root.
    const serviceWorkerRegistration = await navigator.serviceWorker.register(
      `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`
    );
    const token = await getToken(_messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration,
    });
    if (token) {
      await setDoc(
        doc(db, 'fcmTokens', userId),
        { token, user_id: userId, updated_at: serverTimestamp() },
        { merge: true }
      );
    }
  } catch (e) {
    console.warn('Could not register FCM token:', e);
  }
}
